export const serviceType = {
    libraryAudit: "1",
    newCustomer: "2",
    authCardReplacement: "3",
    bidService: "4",
    default: "0",
};
